import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    name: null,
    id_invoice: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token; // Mutación para asignar el token al estado
    },
    setName(state, name) {
      state.name = name; // Mutación para asignar el nombre al estado
    },

    setIdUser(state, id_user) {
      state.id_user = id_user; // Mutación para asignar el nombre al estado
    },
    setIdInvoice(state, id_invoice) {
      state.id_invoice = id_invoice; // Mutación para asignar el nombre al estado
    },
  },
  actions: {},
  modules: {},
});
